import React, { useState } from "react";
import { slider2, presents } from "../../assets/data/Imagedata";
import LineofEngagement from "../../components/LineofEngagement";
import { FaChevronDown } from "react-icons/fa";

const Donations = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    amount: "",
  });

  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is CRC?",
      answer:
        "CRC is an organization dedicated to protecting consumer rights in India. We work to empower citizens, provide legal assistance, and ensure justice for every consumer facing unfair trade practices, defective products, or deficient services.",
    },
    {
      question: "How does my donation help consumers?",
      answer:
        "Your donation helps CRC conduct consumer awareness programs, provide legal guidance, support advocacy campaigns, and strengthen the network of consumer rights defenders across India.",
    },
    {
      question: "Is my donation tax deductible?",
      answer:
        "Yes, all donations to CRC are eligible for tax exemption under Section 80G of the Income Tax Act, 1961.",
    },
    {
      question: "Can I make a monthly contribution?",
      answer:
        "Absolutely! You can choose a one-time or recurring monthly donation to support ongoing consumer protection initiatives.",
    },
    {
      question: "Is online donation through your website safe?",
      answer:
        "Yes. Our website uses secure payment gateways like Razorpay, ensuring your personal and payment information is fully protected.",
    },
    {
      question: "Can I volunteer with CRC?",
      answer:
        "Yes! Volunteers can join awareness programs, assist in campaigns, or support legal initiatives. Contact us to learn more about volunteer opportunities.",
    },
    {
      question: "How can I get updates about CRC’s work?",
      answer:
        "Once you donate or register as a supporter, we’ll keep you updated via email and newsletters about our programs, impact stories, and upcoming initiatives.",
    },
  ];

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handlePayment = async () => {
    try {
      const res = await fetch(
        "https://crcbharat.com/apis/donations/create_order.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("Invalid JSON:", text);
        alert("Server error. Please try again later.");
        return;
      }

      const options = {
        key: data.key,
        amount: data.amount * 100,
        currency: data.currency,
        name: "CRC BHARAT",
        description: "Donation",
        order_id: data.order_id,
        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              "https://crcbharat.com/apis/donations/verify_payment.php",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(response),
              }
            );
            const verifyText = await verifyRes.text();
            const verifyData = JSON.parse(verifyText);

            if (verifyData.status === "success") {
              alert("Thank you for your donation! Payment Successful 💙");
            } else {
              alert("Payment Failed. Please try again.");
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed.");
          }
        },
        prefill: {
          name: data.name,
          email: data.email,
          contact: data.phone,
        },
        theme: { color: "#2563eb" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (err) {
      console.error(err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen py-12">
      {/* HERO SECTION */}
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center px-6 mb-16">
        {/* LEFT */}
        <section className="space-y-6">
          <div className="overflow-hidden rounded-2xl shadow-lg border border-gray-200">
            <img src={slider2} alt="CRC team" className="w-full h-auto object-cover" />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-gray-800 leading-tight">
              Be the Voice for Every Consumer
            </h2>
            <p className="mt-3 text-gray-600 leading-relaxed text-justify">
              Every day, thousands of consumers in India face unfair trade practices, defective products, and deficient services, often without knowing their legal rights. CRC works tirelessly to protect these rights, spread awareness, and provide legal assistance.
            </p>
            <p className="mt-3 text-gray-600 leading-relaxed text-justify">
              By donating to CRC, you help us:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-3">
              <li>Conduct consumer awareness programs across the country</li>
              <li>Provide legal assistance and guidance to marginalized and vulnerable consumers</li>
              <li>Support research, campaigns, and policy advocacy for stronger consumer protection</li>
              <li>Strengthen the network of consumer rights defenders nationwide</li>
            </ul>
            <p className="mt-3 text-lg font-semibold text-blue-700">
              💙 Every contribution ensures that every consumer’s voice is heard
            </p>
          </div>
        </section>

        {/* RIGHT: Payment Form */}
        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-2xl transition duration-300">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
            Support Consumer Protection
          </h2>
          <div className="space-y-4">
            {["name", "email", "phone", "amount"].map((field) => (
              <input
                key={field}
                type={field === "email" ? "email" : field === "amount" ? "number" : "text"}
                name={field}
                placeholder={
                  field === "amount"
                    ? "Donation Amount (INR)"
                    : field === "phone"
                    ? "Phone Number"
                    : field === "email"
                    ? "Email Address"
                    : "Full Name"
                }
                value={form[field]}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              />
            ))}
            <button
              onClick={handlePayment}
              className="w-full py-3 mt-2 bg-blue-600 text-white font-semibold rounded-xl shadow-md hover:bg-blue-700 hover:shadow-lg transition duration-300"
            >
              💙 Donate Today
            </button>
          </div>
          <p className="text-sm text-gray-500 text-center mt-4">
            100% Secure Payment via Razorpay
          </p>
        </div>
      </div>

      {/* LINE */}
      <LineofEngagement />

      {/* PRESENCE SECTION */}
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center px-6 py-16">
        <section className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-200">
          <img src={presents} alt="Our presence" className="w-full h-auto object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </section>

        <section className="space-y-5">
          <h2 className="text-3xl md:text-4xl font-bold text-primary">Our Presence</h2>
          <p className="text-gray-600 text-[16px] leading-relaxed">
            CRC works nationwide, providing legal support and awareness to consumers across India.
          </p>
          <p className="text-gray-600 text-[16px] leading-relaxed">
            Your support helps us empower citizens, strengthen consumer rights networks, and ensure justice for every consumer.
          </p>
          <p className="text-gray-600 text-[16px] leading-relaxed">
            Every contribution takes us closer to building a nation of informed, empowered, and protected consumers.
          </p>
        </section>
      </div>

      {/* FAQ */}
      <div className="max-w-5xl mx-auto py-16 px-6">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-primary mb-10">Frequently Asked Questions</h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
              <button
                className="flex justify-between items-center w-full px-5 py-4 text-left font-medium text-gray-800 hover:bg-gray-50"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                {faq.question}
                <FaChevronDown className={`w-5 h-5 text-gray-600 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`} />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 text-gray-600 text-[15px] leading-relaxed">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Donations;
